import { computed, type Env } from './env.type.ts';

// temp — 배포 환경. web.development 와 동일 형식(절대 baseUrl 직접 호출)이되 BE host 만 temp.*.heviton.net.
// 로컬 dev 서버(vite proxy)로 temp BE 를 붙일 땐 `web.temp.local.ts`(baseUrl 빈값 + proxy) 를 쓴다.
export const env: Env = {
  ...computed,
  buildTarget: 'web',
  // 구독 게이트는 전 환경 defer(=false) — BE 시딩 완료 후 일괄 전환.
  subscriptionGateEnabled: false,
  // 결제 오픈 상태. false 로 두면 구독 퍼널 전체가 채널톡 문의 안내로 돌아간다.
  tossPaymentEnabled: true,
  // 표 엑셀 내보내기 — web 빌드 전용(native 는 CAN_EXPORT_XLSX 의 빌드 상수 항에서 이미 걸린다).
  canExportXlsx: true,
  // temp 배포 도메인.
  deployBaseUrl: 'https://temp.app.heviton.net',
  api: {
    // app-legacy = /api/v3 앱 백엔드(app-user-api).
    appLegacy: { baseUrl: 'https://temp.app-api.heviton.net' },
    // v2 = /api/v2 신규(heviton-api).
    v2: { baseUrl: 'https://temp.web-api.heviton.net' },
    // web-legacy = /api/2.0 (v2 와 동일 BE host).
    webLegacy: { baseUrl: 'https://temp.web-api.heviton.net' },
  },
  // 공개 테스트 키 — 인하우스 dev 에서도 빌링 테스트 가능(헤리트 테스트 키는 Toss 승인 전이라 빌링 불가).
  tossClientKey: 'test_ck_0RnYX2w532wP7AOagKyMVNeyqApQ',
  // web push — dev 프로젝트(heviton-app-user).
  firebase: {
    apiKey: 'AIzaSyCDlfFoe1O6Pu-0h53nujDlDR7FVt16hfM',
    authDomain: 'heviton-app-user.firebaseapp.com',
    projectId: 'heviton-app-user',
    storageBucket: 'heviton-app-user.firebasestorage.app',
    messagingSenderId: '985969867510',
    appId: '1:985969867510:web:83d24895643eb5f6de0ad7',
    measurementId: 'G-WYB8T73HEL',
    vapidKey:
      'BJ07rtdmLfPMh92tBOVzrAEwPvulSVzC9Q72T5OnoOKtZEIn6klGGwwrEsVuxlBi6rOB6Tk60ZWrCxvHR0qzwQc',
  },
};
